import type { CSSProperties } from 'react';
import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { spacing } = theme;

export interface LinkCSSProperties extends CSSProperties {
  '--department-link-color'?: string;
  '--horizontal-padding'?: string;
}

export const item = css`
  display: inline-block;

  &:first-child > a {
    padding-left: 0;
    &:after {
      width: calc(100% - var(--horizontal-padding));
    }
  }

  &:last-child > a {
    padding-right: 0;
    &:after {
      width: calc(100% - var(--horizontal-padding));
    }
  }
`;

export const link = css`
  display: block;
  position: relative;
  text-decoration: none;
  white-space: nowrap;
  padding: ${spacing.sm}px var(--horizontal-padding);
  ${theme.responsiveText.BODY.SM};
  font-weight: 600;
  color: var(--department-link-color, var(--neutral-black-base));

  &:after {
    content: '';
    display: block;
    position: absolute;
    bottom: -1px; // overlap DepartmentsNav bottom border
    width: calc(100% - (2 * var(--horizontal-padding)));
    border-bottom: 3px solid transparent;
  }

  &:hover {
    color: var(--department-link-color, var(--brand-purple-base));
  }

  &[data-active='true'] {
    color: var(--department-link-color, var(--brand-purple-base));
    &:after {
      border-color: var(--department-link-color, var(--brand-purple-base));
    }
  }
`;
